"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CASH_EVENT_LOOSE_TOLERANCE = void 0;
// The reconciliation engine's loose-tolerance band, shared so the backend
// suggestion filter and the frontend diff colouring can never drift apart.
// A cash-event vs. outstanding diff inside ±15% reads as a plausible
// partial-payment/fee gap; anything wider needs a close look.
exports.CASH_EVENT_LOOSE_TOLERANCE = 0.15;
//# sourceMappingURL=operations.js.map